import { Stack } from '@mui/material';
import ProductItem from './ProductItem';
import { Product } from '../../data/hooks/useCustomerLimits';

/**
 * Component that renders a list of available products for a given company.
 *
 * @param products The list of products to be displayed.
 * @returns The rendered component.
 */
const ProductsAvailableList = ({ products }: { products: Product[] }) => {
  return (
    <Stack direction='column' gap={2}>
      {products.map((product) => (
        <ProductItem key={product.name} product={product} />
      ))}
    </Stack>
  );
};

export default ProductsAvailableList;
